import { TW_TextFilterValueEditor, TW_TextFilterValueEditor_editing, TW_TextFilterValueEditor_Wrapper } from "@utils/twClasses";
import { useEffect, useState } from "react";
import Field from "@dto/fields";
import { AbstractFilterValueEditor } from "./AbstractFilterValueEditor";
import { useModelStore } from "src/store";
import { displayText } from "@utils/types";

type TextFilterValueEditorProps = {
    pathKey: string | null;
    field: Field | null;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
}

export function TextFilterValueEditor({ pathKey, field, value, disabled, onValueChange }: TextFilterValueEditorProps) {


    const [text, setText] = useState(value || "");
    const [editing, setEditing] = useState(false);
    const selectedView = useModelStore(state => state.selectedView);
    const format = selectedView?.formats?.get(pathKey ?? "") ?? field?.format;


    useEffect(() => {
        setText(value || "");
    }, [value]);

    const textToValue = (text: string | null): any => {
        return displayText(text, format);
    }

    function isTextValid(value: string | null) {
        return true;
    }


    const onReadOnlyClick = () => {
        if (!disabled) {
            setEditing(true);
        }
    }

    const renderReadOnlyContent = () => {
        return (
            <div className={TW_TextFilterValueEditor_Wrapper} onClick={onReadOnlyClick}>
                <div className={TW_TextFilterValueEditor + (!disabled ? " cursor-pointer opacity-100" : " cursor-not-allowed opacity-50")}>
                    {(value !== undefined) ? value : ""}
                </div>
            </div>)
    }

    const renderEditingContent = (
        onBlur: () => void,
        onEnterKeyPress: (event: React.KeyboardEvent) => void,
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        getText: () => string | null) => {
        return (<div tabIndex={0} className={TW_TextFilterValueEditor_Wrapper} onKeyDown={onEnterKeyPress}>
            <input
                className={TW_TextFilterValueEditor_editing}
                type="text"
                value={text}
                onBlur={onBlur}
                onChange={onTextChange}
                autoFocus={true}
                disabled={disabled} />
        </div>)
    }

    return <AbstractFilterValueEditor
        initialValue={value}
        editing={editing}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        getText={() => text}
        setText={setText}
        setEditing={setEditing}
        onValueChange={onValueChange} />
}
